module.exports = __webpack_public_path__ + "img/1503895985.40571200.jpg";